module.exports = __webpack_public_path__ + "img/6.d337c12f.png";